<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    firstLine?: string;
    secondLine?: string;
    mutedSecondLine?: boolean;
  }>(),
  {
    firstLine: '',
    secondLine: '',
    mutedSecondLine: false,
  },
);

const emit = defineEmits<{
  (e: 'change-click'): void;
}>();
</script>

<template>
  <div class="mbw-chosen-card">
    <div class="mbw-chosen-card-icon">
      <slot name="icon" />
    </div>

    <div class="mbw-chosen-card-content">
      <div class="mbw-chosen-card-text">
        <div
          v-if="props.firstLine"
          class="mbw-chosen-card-first-line"
        >
          {{ props.firstLine }}
        </div>
        <div
          v-if="props.secondLine"
          class="mbw-chosen-card-second-line"
          :class="{ 'mbw-chosen-card-second-line--muted': props.mutedSecondLine }"
        >
          {{ props.secondLine }}
        </div>
      </div>
    </div>

    <button
      type="button"
      class="mbw-chosen-card-change"
      @click="emit('change-click')"
    >
      Zmień
    </button>
  </div>
</template>

<style scoped>
.mbw-chosen-card {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  border-radius: 9px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  padding: 10px 12px;
  box-sizing: border-box;
}

.mbw-chosen-card-icon {
  flex-shrink: 0;
  margin-right: 8px;
}

.mbw-chosen-card-content {
  flex: 1;
  min-width: 0;
}

.mbw-chosen-card-first-line {
  font-size: 14px;
  font-weight: 500;
  color: #3c3d41;
  margin-bottom: 6px;
}

.mbw-chosen-card-second-line {
  font-size: 14px;
  color: #3c3d41;
  margin-top: 2px;
}

.mbw-chosen-card-second-line--muted {
  color: #898989;
}

.mbw-chosen-card-change {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--mbw-primary, #017bc4);
  cursor: pointer;
  white-space: nowrap;
  margin-right: 12px;
}
</style>

